import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { useTranslation } from 'react-i18next'

export default function Notification(props) {
  const { notification, clearNotification } = props
  const { t } = useTranslation()


  const type = notification && notification.type ? notification.type : 'success'
  if (notification) {
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={!!notification}
        autoHideDuration={5000}
        onClose={clearNotification}
      >
        <MuiAlert variant='filled' severity={type} onClose={clearNotification}>
          {notification ? t(notification.text) : null}
        </MuiAlert>
      </Snackbar>
    )
  }
  return null
}
